import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            热度排行
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            热播榜单
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-xl mx-auto">
            本周播放量排行榜，看看大家都在追哪些热门剧集完整版
          </p>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 md:px-6 py-4 border-b border-background-100 last:border-b-0 hover:bg-background-50 transition-colors duration-150 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold text-foreground-900 text-sm md:text-base truncate">
                    {item.title}
                  </h3>
                  {item.isTop && (
                    <span className="flex-shrink-0 text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium">
                      HOT
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{item.category}</span>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-xs md:text-sm font-medium text-accent-600">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}